import React, { useState } from 'react';
import { Link } from 'react-router-dom';


import '../../../commonStyles/CommonRouteStyles.css'
import '../../navigation/EdgeNavigation.css'

import HomeRoutetNavigationButton from '../../components/home/navigation/HomeRouteNavigationButton';
import FeaturedProjects from '../../components/home/projects/FeaturedProjects'
import NonFeaturedProjects from '../../components/home/projects/Non-FeaturedProjects'
import PhotoGallery from '../../components/home/photoGallery/PhotoGallery';

export default function Projects() {


    const [featuredProjects, featuredProjectsOpened] = useState(true);
    const [nonFeaturedProjects, nonFeaturedProjectsOpened] = useState(false);
    const [photoGallery, photoGalleryOpened] = useState(false)

    return (
        <section id='Home-Route'>

            <div className='Edge-Section-Position-Left Edge-Section-Flex Edge-Section-Dimensions'>
                <Link to="/resume" className='Edge-Button-Dimension'>
                    <button className="EdgeButtons-Colors Edge-Button-Dimension"></button>
                </Link>
            </div>

            {featuredProjects &&
                (
                    <>
                        <header id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                            <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Spacing HomeRoute-Header-Dimensions HomeRoute-Header-Shape HomeRoute-Header-Position'>
                                <h1>Featured Projects</h1>
                            </button>
                        </header>
                        <FeaturedProjects></FeaturedProjects>
                    </>
                )}

            {nonFeaturedProjects &&
                (
                    <>
                        <header id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                            <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Spacing HomeRoute-Header-Dimensions HomeRoute-Header-Shape HomeRoute-Header-Position'>
                                <h1>Non-Featured Projects</h1>
                            </button>
                        </header>
                        <NonFeaturedProjects></NonFeaturedProjects>
                    </>

                )}

            {photoGallery &&
                (
                    <>
                        <header id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                            <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Dimensions HomeRoute-Header-Shape'>
                                <h1>Photo Gallery</h1>
                            </button>
                        </header>
                        <PhotoGallery></PhotoGallery>
                    </>
                )}

            <HomeRoutetNavigationButton
                featuredProjects={featuredProjects}
                featuredProjectsOpened={featuredProjectsOpened}
                nonFeaturedProjects={nonFeaturedProjects}
                nonFeaturedProjectsOpened={nonFeaturedProjectsOpened}
                photoGallery={photoGallery}
                photoGalleryOpened={photoGalleryOpened}
            >
            </HomeRoutetNavigationButton>

            <div className='Edge-Section-Position-Right Edge-Section-Flex Edge-Section-Dimensions'>
                <Link to="/resume" className='Edge-Button-Dimension'>
                    <button className="EdgeButtons-Colors Edge-Button-Dimension"></button>
                </Link>
            </div>

        </section>
    )
}